import API from "./index"

class ResourceService {
    constructor(path) {
        this.path = path
    }

    findAll({
        page = 0,
        size = 10,
        filter = false,
        isOrOperation = undefined,
        params = {},
    }) {
        params.page = page - 1 < 0 ? 0 : page - 1
        params.size = size
        filter ? (params.filter = filter) : null
        if (params.isOrOperation) params.isOrOperation = isOrOperation
        return API.get(this.path, {
            params,
            responseEncoding: false,
        })
    }

    find() {
        return API.get(`${this.path}`)
    }
    findById(id) {
        return API.get(`${this.path}/${id}`)
    }





    async saveFormData(id, record) {

        if (id) {
            return API.put(`${this.path}/${id}`, record).then(
                (response) => {
                    return { created: false, ...response };
                }
            ).catch(error => {
                throw error;
            });
        }

        return API.post(this.path, record).then((response) => {
            return {
                created: true,
                ...response,
            };
        }).catch(error => {
            throw error;
        });
    }


    async save(record) {

        if (record.id) {
            return API.put(`${this.path}/${record.id}`, record).then(
                (response) => {
                    return { created: false, ...response };
                }
            ).catch(error => {
                throw error;
            });
        }

        return API.post(this.path, record).then((response) => {
            return {
                created: true,
                ...response,
            };
        }).catch(error => {
            throw error;
        });
    }

    async saveForm(record) {
        if (record.id) {
            return API.put(`${this.path}/${record.id}`, record)
        }

        return API.post(this.path, record)
    }



    async saveWithId(record) {
        return API.post(this.path, record).then(({ ...args }) => ({
            created: true,
            ...args,
        }))
    }

    alteraSituacao({ id, situacao }) {
        return API.put(`${this.path}/${id}/situacao`, { situacao }).then(
            ({ ...args }) => ({ created: false, ...args })
        )
    }

    alteraVisivel({ id, visivel }) {
        return API.put(`${this.path}/${id}/visivel`, { visivel }).then(
            ({ ...args }) => ({ created: false, ...args })
        );
    }

    alteraBloqueado({ id, bloqueado, justificativaBloqueio, mensagemBloqueio }) {
        return API.put(`${this.path}/${id}/bloqueado`, {
            bloqueado,
            justificativaBloqueio,
            mensagemBloqueio,
        }).then(({ ...args }) => ({ created: false, ...args }));
    }

    updateStatus(id, statusId, justificativa) {
        return API.put(`${this.path}/${id}/changestatus`, { statusId, justificativa });
    }

    remove(id) {
        if (!id) {
            throw new Error("ID cannot be null")
        }

        return API.delete(`${this.path}/${id}`)
    }


    delete(url) {

        return API.delete(`${this.path}/${url}`)
    }

    removeList(data) {

        return API.delete(`${this.path}`, {params: {ids: data.join(',')}})
    }


    post(path, data) {
        return API.post(`${this.path}/${path}`, data)
    }

    put(path, data) {
        return API.put(`${this.path}/${path}`, data)
    }

    get(path) {
        return API.get(`${this.path}/${path}`)
    }

    getWithParams(path, params) {

        return API.get(`${this.path}/${path}`, {
            params,
        });
    }


    countByStatus(filtro) {
        return API.get(
            `${this.path}/statusId/${filtro.statusId}/departamentoId/${filtro.departamentoId}`
        )
    }
}

export default ResourceService
